module.exports = __webpack_public_path__ + "img/backyard-alt-wide.00d4749d.webp";